// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"ae2d15a1","787":"f0407440"}[chunkId] + ".chunk.js";
};